// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_getPendingAttendanceBonuses = () => "/attendance-bonus/pending";

export type TSpecHandler_getPendingAttendanceBonuses = RequestHandler<TSpecPathGetPendingAttendanceBonuses, any, TSpecBodyGetPendingAttendanceBonuses, TSpecQueryGetPendingAttendanceBonuses, {}>;

export interface TSpecPathGetPendingAttendanceBonuses {  }

export interface TSpecBodyGetPendingAttendanceBonuses {}

export interface TSpecQueryGetPendingAttendanceBonuses {
  AppVersion?: string;
  AppUser?: string;
}
